import script from "./UserCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCardModal.vue?vue&type=script&setup=true&lang=js"

import "./UserCardModal.vue?vue&type=style&index=0&id=05847af0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05847af0"]])

export default __exports__